import { render, staticRenderFns } from "./MainWrapper.vue?vue&type=template&id=38bf8f5a&scoped=true&"
import script from "./MainWrapper.vue?vue&type=script&lang=ts&"
export * from "./MainWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./MainWrapper.vue?vue&type=style&index=0&id=38bf8f5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bf8f5a",
  null
  
)

export default component.exports